module.exports = __webpack_public_path__ + "img/download.17f4d0cf.svg";